import React from "react";
import { fmtDate, rupees } from "../Insights/format";

const TEXT_COLUMNS = [
  ["mode_label", "Mode"],
  ["account", "To account"],
  ["reference", "Reference"],
  ["collected_by", "Collected by"],
  ["notes", "Note"],
  ["recorded_by", "Recorded by"],
];

export default function PaymentsTable({ rows, loading, showRider = false, onDelete, emptyText = "No payments in this period" }) {
  const columns = TEXT_COLUMNS.length + 2 + (showRider ? 1 : 0) + (onDelete ? 1 : 0);
  return (
    <div className="stl-scroll">
      <table className="stl-table">
        <thead>
          <tr>
            <th className="stl-left">Paid on</th>
            {showRider && <th className="stl-left">Rider</th>}
            <th>Amount</th>
            {TEXT_COLUMNS.map(([key, title]) => (
              <th key={key} className="stl-left">
                {title}
              </th>
            ))}
            {onDelete && <th aria-label="Actions" />}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns} className="stl-no-match">
                {loading ? "Loading payments…" : emptyText}
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr key={row.id}>
                <td className="stl-left">{fmtDate(row.paid_on)}</td>
                {showRider && (
                  <td className="stl-left">
                    <a className="rider-order-link" href={`/deliboy/${row.rider.id}`}>
                      {row.rider.name || `Rider #${row.rider.id}`}
                    </a>
                  </td>
                )}
                <td>
                  <span className="stl-strong">{rupees(row.amount)}</span>
                </td>
                {TEXT_COLUMNS.map(([key]) => (
                  <td key={key} className={`stl-left${key === "notes" ? " rider-note" : ""}`}>
                    {row[key] || "—"}
                  </td>
                ))}
                {onDelete && (
                  <td>
                    <button type="button" className="stl-link-btn" onClick={() => onDelete(row)}>
                      Delete
                    </button>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
